import React, {ReactNode} from 'react';
import classNames from "classnames";
import {useUserState} from "@stores/AppStateContext";

import {ClientUser} from "../../../API";
import {UserAvatar} from "../Avatar/Avatar";
import {getFullNameOrEmpty} from "../../../utils/userHelper";

import './UserCard.css';

export interface UserCardProps {
    user: ClientUser;
    className?: string;
    isEmail?: boolean;
    size?: UserCardSize;
    isInline?: boolean;
    emailWithBrackets?: boolean;
    additionalInfo?: ReactNode
    isBoldStyle?: boolean
    withBackground?: boolean
}

export type UserCardSize = 24 | 36 | 40;

export const UserCard = (
    {
        user,
        className,
        isEmail,
        size,
        isInline = false,
        emailWithBrackets = false,
        additionalInfo,
        isBoldStyle,
        withBackground
    }:
        UserCardProps) => {
    const userState = useUserState();
    const {email} = user;
    const fullNameOrEmpty = getFullNameOrEmpty(user);
    return (
        <div className={classNames({
            'UserCard': true,
            'UserCard--inline': isInline,
            'UserCard__withBackground': withBackground,
            [className!]: className,
            [`UserCard--${size}`]: size,
        })}>
            <UserAvatar user={userState!.usersDS.users.get(user.id)!} size={size}/>
            <div className={classNames({
                "UserCard-block": true,
                [`UserCard_block--${size}`]: size,
            })}>
                {
                    fullNameOrEmpty
                        ? (
                            <div className={classNames({
                                "body-large": true,
                                "body-large-bold": isBoldStyle,
                                "UserName": true,
                                [`UserName--${size}`]: size,
                            })}>
                                {fullNameOrEmpty}
                            </div>
                        )
                        : null
                }
                {
                    isEmail
                        ? (
                            <div className={classNames({
                                "body-large UserEmail": true,
                                [`UserCard_email--${size}`]: size,
                            })}>
                                {
                                    emailWithBrackets
                                        ? `(${email})`
                                        : email
                                }
                            </div>
                        )
                        : null
                }
                {
                    additionalInfo && (
                        <div className={classNames({
                            "body-large UserEmail": true,
                            [`UserCard_email--${size}`]: size,
                        })}>
                            {additionalInfo}
                        </div>)
                }
            </div>
        </div>
    )
}

